import * as React from 'react';
import styled from 'styled-components';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Controller, useFormContext } from 'react-hook-form';
import FieldWrapper from './FieldWrapper';
import { ListProps } from './ComboBox';
import { hasValue, isOptionArray, getActualValue } from '../../../lib/utils';
import { createRules } from './utils';
import { fieldBackgroundWhite, fieldBorder } from '../../cssConstants';

const WrappedDropDownList = <T,>(props: Props<T>) => {
	const { fieldName, label, dataValues, className, required, onChange } = props;
	const textField = isOptionArray(dataValues) ? 'text' : undefined;
	const dataItemKey = isOptionArray(dataValues) ? 'value' : undefined;
	const { control, getValues } = useFormContext();
	return (
		<FieldWrapper fieldName={fieldName} label={props.disabled ? null : label}>
			<Controller
				name={fieldName}
				control={control}
				rules={createRules(required)}
				defaultValue={getValues(fieldName)}
				render={(controllerProps) => (
					<DropDownListDecorator width={props.width} disabled={props.disabled}>
						<DropDownList
							value={getActualValue(controllerProps.field.value, dataValues)}
							textField={textField}
							dataItemKey={dataItemKey}
							className={className}
							data={dataValues}
							disabled={props.disabled}
							onChange={(e) => {
								const value = hasValue(e.target.value?.value) ? e.target.value.value : e.target.value;
								controllerProps.field.onChange(value);
								if (onChange) onChange(e);
							}}
						/>
					</DropDownListDecorator>
				)}
			/>
		</FieldWrapper>
	);
};

interface Props<T> extends ListProps<T> {
	width?: string;
	className?: string;
	disabled?: boolean;
	onChange?: (e: any) => void;
}

WrappedDropDownList.defaultProps = {
	width: null,
	className: null,
	disabled: false
};

export default WrappedDropDownList;

const borderRadius = '8px';

const DropDownListDecorator = styled.div<{ width: string; disabled: boolean }>`
	margin-top: ${(props) => (props.disabled ? '15px' : '0')};
	.k-dropdown {
		height: 36px;
		${(props) => (props.width ? `width: ${props.width};` : null)}
		font-size: 16px;
		line-height: 21px;
		font-weight: normal;
		background-color: ${fieldBackgroundWhite};
		border: ${fieldBorder};
		border-radius: ${borderRadius};
		overflow: hidden;

		.k-dropdown-wrap {
			border-radius: ${borderRadius};
			border: none;

			.k-input {
				border-top-left-radius: ${borderRadius};
				border-bottom-left-radius: ${borderRadius};
			}

			.k-select {
				border-top-right-radius: ${borderRadius};
				border-bottom-right-radius: ${borderRadius};
			}

			.k-input,
			.k-select {
				background-color: ${fieldBackgroundWhite};
			}
		}
	}
`;
